import { type MonoTypeOperatorFunction } from 'rxjs';
import { tap } from 'rxjs/operators';
import { logger } from './logger';

export function debug(
  message: string,
  showDebug: boolean = true
): MonoTypeOperatorFunction<unknown> {
  return tap(
    (next: unknown) => {
      if (showDebug) {
        logger.warn(message, next);
      }
    },
    (err: unknown) => {
      if (showDebug) {
        logger.error('ERROR >>> ', message, err);
      }
    },
    () => {
      if (showDebug) {
        logger.warn(message, 'Completed');
      }
    }
  );
}
